module.exports = __webpack_public_path__ + "img/Paypal.e2df43a7.svg";